import React from 'react'
import ReactDOM from 'react-dom'
import { RiCloseLine } from 'react-icons/ri'
import './stylesheets/Modal.css'

const Modal = ({ setIsModalOpen, children, backGroundClass, dismissModal }) => {
  // Try to find your app’s wrapper div
  const outerContainer = document.getElementById('outer-container')

  // Fallback to body if it’s not yet mounted
  const portalTarget = outerContainer || document.body

  const modalMarkup = (
    <>
      <div
        className={`${backGroundClass}`}
        onClick={() => {
          setIsModalOpen(false)
          if (typeof dismissModal === 'function') dismissModal()
        }}
      />
      <div className="centered">
        <div className="modal rounded">
          <button
            className="closeBtn z-50"
            onClick={() => {
              setIsModalOpen(false)
              if (typeof dismissModal === 'function') dismissModal()
            }}
          >
            <RiCloseLine style={{ marginBottom: '-3px' }} />
          </button>
          {children}
        </div>
      </div>
    </>
  )

  return ReactDOM.createPortal(modalMarkup, portalTarget)
}

export default Modal
